<template>
  <div :class="['select-none flex w-[160px] whitespace-nowrap shadow-lg p-2 rounded-full items-center justify-center', toggle_color]">
    <template v-if="current_status == 'completed'">
      <Check
        v-if="!disableToggle"
        v-tooltip="`Toggle status left`"
        :disabled="!can_toggle_left"
        :class="[
          ` text-white dark:text-black h-5 w-5 disabled:hover:cursor-default !bg-transparent cursor-pointer disabled:hover:text-white hover:shadow-xl shadow-inner opacity-0`,
          { disabled: !can_toggle_left, 'opacity-100': can_toggle_left },
          toggle_color
        ]"
        @click.stop="() => (can_toggle_left ? toggleStatus('left') : void null)" />
    </template>
    <template v-else>
      <ChevronLeft
        v-if="!disableToggle"
        v-tooltip="`Toggle status left`"
        :disabled="!can_toggle_left"
        :class="[
          ` text-white dark:text-black h-5 w-5 disabled:hover:cursor-default !bg-transparent cursor-pointer disabled:hover:text-white hover:shadow-xl shadow-inner opacity-0`,
          { disabled: !can_toggle_left, 'opacity-100': can_toggle_left, 'rotate-180': $store.state.portfolio.ui_options?.language == 'ar' },
          toggle_color
        ]"
        @click.stop="() => (can_toggle_left ? toggleStatus('left') : void null)" />
    </template>
    <Menu as="div" class="relative flex-1 flex-shrink-0 text-center cursor-default">
      <MenuButton
        :class="[
          `select-none  text-white dark:text-black disabled:hover:cursor-default ${'cursor-pointer'} disabled:hover:text-white hover:shadow-xl shadow-inner inline-flex w-[90px]  items-center justify-center border-1 rounded-full focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue`
        ]"
        @click.stop>
        <span class="capitalize">{{ statuses.find((s) => s.value == current_status).label }}</span>
      </MenuButton>
      <transition
        v-if="!disableToggle"
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0">
        <MenuItems
          v-if="!hideDropDown"
          class="absolute z-10 mx-3 -ml-8 origin-bottom-right bg-transparent border-0 w-[165px] space-y-1 mt-2.5 focus:outline-none text-center">
          <div v-for="status in statuses" :key="status" class="">
            <div class="">
              <MenuItem v-slot="{ active }">
                <div
                  :class="[
                    active ? 'bg-gray-100 dark:bg-dark-screen-background text-gray-400' : 'text-gray-700 dark:text-dark-body-text',
                    'border bg-white dark:bg-dark-screen-background rounded-full dark:border-dark-divider-border cursor-pointer group flex items-center px-4 py-2 text-sm w-full justify-center capitalize shadow-lg'
                  ]"
                  @click.stop="switchStatus(status)">
                  {{ status.label }}
                </div>
              </MenuItem>
            </div>
          </div>
        </MenuItems>
      </transition>
    </Menu>
    <ChevronRight
      v-if="!disableToggle"
      v-tooltip="`Toggle status right`"
      :disabled="!can_toggle_right"
      :class="[
        `text-white dark:text-black h-5 w-5 disabled:hover:cursor-default !bg-transparent dark:bg-dark-screen-background cursor-pointer disabled:hover:text-white hover:shadow-xl shadow-inner opacity-0`,
        { disabled: !can_toggle_right, 'opacity-100': can_toggle_right, 'rotate-180': $store.state.portfolio.ui_options?.language == 'ar' },
        toggle_color
      ]"
      tooltip="Toggle status right"
      @click.stop="() => (can_toggle_right ? toggleStatus('right') : void null)" />
  </div>
</template>

<script>
import { ChevronRight, Check, ChevronLeft } from "lucide-vue-next"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
export default {
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ChevronRight,
    ChevronLeft,
    Check
  },
  props: {
    currentStatus: {
      type: String,
      default: "not_started"
    },
    hideDropDown: {
      type: Boolean,
      required: false
    },
    disableToggle: {
      type: Boolean,
      required: false
    }
  },
  emits: ["change"],
  data() {
    return {
      statuses: [
        { label: this.$t("Not started"), value: "pending" },
        { label: this.$t("In progress"), value: "in-progress" },
        { label: this.$t("Overdue"), value: "overdue" },
        { label: this.$t("Completed"), value: "completed" }
      ],
      current_status: "pending"
    }
  },
  computed: {
    can_toggle_left() {
      return !this.disableToggle && this.statuses.findIndex((s) => s.value == this.current_status) > 0
    },
    can_toggle_right() {
      return !this.disableToggle && this.statuses.findIndex((s) => s.value == this.current_status) < this.statuses.length - 1
    },
    toggle_color() {
      return {
        not_started: "dark:bg-dark-light-blue bg-light-light-blue",
        pending: "dark:bg-dark-light-blue bg-light-light-blue",
        "in-progress": "dark:bg-dark-brand-blue bg-light-brand-blue",
        overdue: "bg-status-warning-yellow dark:bg-status-warning-yellow",
        completed: "bg-status-success-green dark:bg-status-success-green",
        cancelled: "bg-status-error-red dark:bg-status-error-red",
        missed: "bg-status-error-red dark:bg-status-error-red"
      }[this.current_status]
    }
  },
  watch: {
    currentStatus(newStatus) {
      this.current_status = newStatus
    }
  },
  created() {
    this.current_status = this.currentStatus
  },
  methods: {
    toggleStatus(direction) {
      let status_index = this.statuses.findIndex((s) => s.value == this.current_status)
      if (direction == "left") {
        status_index -= 1
      } else {
        status_index += 1
      }
      this.switchStatus(this.statuses[status_index])
    },
    switchStatus(status) {
      this.current_status = status.value
      this.$emit("change", this.current_status)
    }
  }
}
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
